const AP = {
  id: '0',
  year: 'PRIOR',
  semesters: [
    {
      id: '1000',
      semesterName: 'Advanced Placement',
      courses: []
    },
    {
      id: '1001',
      semesterName: 'Dual Enrollment',
      courses: []
    },
    {
      id: '1002',
      semesterName: 'Others',
      courses: []
    }
  ]
}

export default [
  AP,
  {
    id: "100",
    year: "FRESHMAN",
    semesters: [
      {
        id: "1",
        semesterName: "Fall semester",
        courses: []
      },
      {
        id: "2",
        semesterName: "Spring semester",
        courses: []
      },
      {
        id: "12",
        semesterName: "Summer semester",
        courses: []
      }
    ]
  },
  {
    id: "200",
    year: "SOPHOMORE",
    semesters: [
      {
        id: "3",
        semesterName: "Fall semester",
        courses: []
      },
      {
          id: "4",
          semesterName: "Spring semester",
          courses: []
      },
      {
        id: "11",
        semesterName: "Summer semester",
        courses: []
      }
    ]
  },
  {
    id: "300",
    year: "JUNIOR",
    semesters: [
      {
        id: "5",
        semesterName: "Fall semester",
        courses: []
      },
      {
        id: "6",
        semesterName: "Spring semester",
        courses: []
      },
      {
        id: "10",
        semesterName: "Summer semester",
        courses: []
      }
    ]
  },
  {
    id: "400",
    year: "SENIOR",
    semesters: [
      {
        id: "7",
        semesterName: "Fall semester",
        courses: []
      },
      {
        id: "8",
        semesterName: "Spring semester",
        courses: []
      },
      {
        id: "9",
        semesterName: "Summer semester",
        courses: []
      }
    ]
  }
];
